<script>
    import Vue from 'vue'
    import axios from 'axios';
    
    export default {
        install(Vue, options) {
            var apiDomain = options.apiDomain;
            var region = options.region;
            var store = options.store;
            var results = null;
            Vue.prototype.$pagesService = {                
                async getTeamPage (id) {
                    let params_query = {
                        params: {
                            region: region,
                            pageType: "T",
                            excludepageswithrestrictedcreation: "true",
                            pageid: id
                        }
                    }
                    await axios.get(apiDomain + "/v1/pages/search", params_query).then(function(res) {
                        if (res.data.Pages && res.data.Pages.length > 0 && res.data.Pages[0].Id === id) {
                            results = res.data.Pages[0];
                        }
                    });

                    return results;
                },

                generateCreatePageUrl() {
                    var params = "";
                    var eventId = store.state.selected_event.EventCampaignId;
                    var charityId = store.state.selected_charity.beneficiaryId;
                    
                    if (store.state.pageType !== 'joinTeam') {
                        var pageType = store.state.pageType === "createTeam" ? "t" : "s";
                        params = "pagetype=" + pageType + "&eid=" + eventId + "&cid=" + charityId;
                    } else {
                        params = "tid=" + store.state.selected_teampage.page.Id;
                    }
                    
                    if (store.state.referrer && store.state.referrer !== "") {                                               
                        params = params + "&eidtype=" + store.state.referrer;
                        
                    }

                    return "/pages/create?" + params;
                }
            }
        }
    }
</script>